import user from "./login";
import signup from "./signup";
import redemption from "./redemption";
import snackbar from "./snackbar";
import customerRegisteration from "./customerRegisteration";

export default {
  user,
  signup,
  redemption,
  snackbar,
  customerRegisteration
};
